import React, { useEffect, useRef, useState } from "react";
import WelcomeJourneyFooter from "../WelcomeJourneyFooter";

const PreNotificationPopup = (props) => {
    const [showFooter, setShowFooter] = useState(true);
    const notificationOptinRef = useRef(null);

    const handlebtn1Click = (e) => {
        window?.ReactNativeWebView?.postMessage(JSON.stringify({ welcomeJourneyStep2: true }));
        setShowFooter(false);
    }

    //listent to event from react native and trigger next step
    useEffect(() => {
        const observerCallback = (mutationList) => {
            mutationList.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    props.changeStep(2);
               }
            })
        }

        const observer = new MutationObserver(observerCallback);

        if(notificationOptinRef.current) {
            observer.observe(notificationOptinRef.current, {
                attributes: true,
                attributeFilter: ['class']
            });
        }

        return () => {
            observer.disconnect();
        }
    }, []);

    return (
        <>
            <div ref={notificationOptinRef} className="rewards_block" style={{
                backgroundImage: "url('https://cdn.shopify.com/s/files/1/0555/6165/0255/files/800x1340_x2_37ec71c4-1554-4117-85e0-06b2875f6b93.png?v=1713247880",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover"
            }}>&nbsp;</div>
          
            { showFooter && <WelcomeJourneyFooter
                heading="Be the first to know"
                description="Allow notifications for curated style picks, brand debuts, exclusive events and more."
                btn1_text="Continue"
                btn1ClickHandler={handlebtn1Click}
                ga4tag1={"App: WJ - Notifications > Continue"}
            />}
            
    </>
  );
};

export default PreNotificationPopup;
